<template>
	<div class="jiangli">
		<div class="jiangli_top">
			<img @click="fanhui()" src="../../assets/images/licai/fanhui.png"/>
			<p class="">资讯详情</p>
		</div>
		<div class="jiangli_con">
			<div class="jiangli_con_cnt">
				<h4 style="text-align: center;">下半年银行理财转型分化将加剧</h4>
				
				 <p class="" style="text-align: center;">发布时间：2020-11-21     阅读：98人</p>
				 <img src="../../assets/images/licai/banner.png" />
				
				<p class="">近日，银行业金融登记托管中心发布的数据显示，截至6月末，325家银行机构、20家理财公司累计存管理财产品25.80万亿USD，同比增长5.37%。</p>

				<p class="">中国银行研究院认为，加快转型、提质增效、稳定收益是上半年理财业务发展的“关键词”。预计下半年银行融资规模将企稳回升，但增速将放缓。</p>

				<p class="">具体来看，一方面，在经历了资管新规过渡期和适应期、理财新产品开发期后，银行理财规模稳步回升，银行正在逐步走出资管新规的“阵痛期”；另一方面，2021年，银行加快理财业务调整，减轻压力，整改不合格理财产品，新产品被市场接受时间较长。因此，理财规模增速可能下降，预计稳定在5%-6%左右。</p>

				<p class="">数据显示，截至6月底，净值型理财产品存续规模占比接近80%，而保本型产品持续下降。中行研究院表示，下半年理财净值转型将加快。除“一行一策”安排的特殊资产外，预计年底前银行理财整体净值将提前实现。</p>
=
				<p class="">此外，中国银行研究院预测，下半年银行理财转型分化将加剧。大型银行将充分发挥综合性、一体化优势，大力布局财富管理业务。中小银行将回归原有业务，更加注重代销服务。</p>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "GoodsEvaluate",
		data: function() {
			return {
				types:0,
			};
		},
		created() {
	
		},
		mounted: function() {
			
		},
		methods: {
			fanhui:function(){
				this.$router.push({
					path:'/'
				})
			}
		},
	};
</script>
<style>
	h4{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 43px;
		opacity: 0.99;
	}
	.jiangli_con_tou{
		text-align: center;
	}
	.jiangli_con_cnt img{
		width: 100%;
	}
	.jiangli_con_cnt p{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 28px;
		opacity: 0.99;
	}
	.jiangli_con{padding: 30px 15px;}
	.jiangli_top{
		width: 100%;
		height: 45px;
		line-height: 45px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.jiangli_top img{
		height: 30px;
		width: 30px;
		position: absolute;left: 0px;
	}
	.jiangli_top p{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333!important;
		text-align: center;
	}
</style>

